// ===========================================================================
// ProCare.SG — Central company / brand configuration
// Single source of truth for contact details, nav, and brand constants.
// A future backend can override these via a settings endpoint.
// ===========================================================================

export const COMPANY = {
    name: "ProCare.SG",
    uen: "2026XXXXXX",
    email: "ask@procare.sg",
    mobile: "+65 8421 2329",
    mobileRaw: "6584212329",
    whatsapp: "https://wa.me/6584212329",
    address: {
        line1: "4033 Ang Mo Kio Industrial Park 1",
        line2: "#01-82",
        line3: "Singapore 569640",
    },
    tagline: "Your MOVE. Our CARE.",
    logo: "/images/logo.png",
};

// Build an encoded WhatsApp link with an optional pre-filled message.
export const waLink = (message) => {
    const base = `https://wa.me/${COMPANY.mobileRaw}`;
    if (!message) return base;
    return `${base}?text=${encodeURIComponent(message)}`;
};

export const WA_MESSAGES = {
    general:
        "Hi ProCare.SG, I would like to enquire about your property services.",
    quote: "Hi ProCare.SG, I would like to request a free quote for my property.",
    moving:
        "Hi ProCare.SG, I would like to request a quotation for moving services.",
    cleaning:
        "Hi ProCare.SG, I would like to request a quotation for cleaning services.",
    painting:
        "Hi ProCare.SG, I would like to request a quotation for painting services.",
    "mould-treatment":
        "Hi ProCare.SG, I would like to arrange an inspection for a mould issue.",
    "spalling-concrete-repairs":
        "Hi ProCare.SG, I would like to arrange an inspection for spalling concrete.",
    "events-set-up":
        "Hi ProCare.SG, I would like to enquire about your events set-up services.",
};

export const MAIN_NAV = [
    { label: "Home", to: "/" },
    { label: "About Us", to: "/about-us" },
    { label: "Services", to: "/services", dropdown: "services" },
    {
        label: "Other Solutions",
        to: "/special-solutions",
        dropdown: "special",
    },
    { label: "Our Works", to: "/our-works" },
    { label: "Testimonials", to: "/testimonials" },
    { label: "Blog", to: "/blog" },
    { label: "Contact", to: "/contact" },
];
